import React, { useState, useEffect } from "react";
import {
  Button,
  CircularProgress,
  Box,
  Switch,
  Stack,
  Typography,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import API from "../../../axios";
import { InputField } from "../../../components";
import { openPopUp } from "../../../store/reducer";

export default function ProjectUserForm({
  item = null,
  afterSubmit = () => {},
  closeForm,
}) {
  const [formErrors, setFormErrors] = useState();
  const { selectedLang, language } = useSelector((state) => state.storeReducer);
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    status: true,
  });

  const dispatch = useDispatch();

  useEffect(() => {
    if (!!item) {
      setFormData({
        name: item.name,
        status: item?.active,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleChange = (e) => {
    var { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleForm = async (e) => {
    setFormErrors({});
    e.preventDefault();
    setIsLoading(true);
    let obj = {
      name: formData?.name,
      status: formData?.status,
    };
    let _url = `admin/update-project-user/${item?.project_parent_id}/${item?.id}`;
    try {
      await API("post", _url, obj);
      setIsLoading(false);
      dispatch(
        openPopUp({
          message: language[selectedLang]?.client_update,
          type: "success",
        })
      );
      afterSubmit();
    } catch (err) {
      let errObj = {};
      if (err?.response?.status === 422) {
        for (const [key, value] of Object.entries(
          err?.response?.data?.detail
        )) {
          errObj = { ...errObj, [key]: value[0] };
        }
        setFormErrors(errObj);
      } else {
        dispatch(
          openPopUp({
            message:
              err?.response?.data?.message || language[selectedLang]?.error_msg,
            type: "error",
          })
        );
      }
      setIsLoading(false);
    }
  };

  return (
    <Box component="form" autoComplete="off" onSubmit={handleForm}>
      <Box maxWidth="500px" mx="auto">
        <Stack spacing={2}>
          <InputField
            type="text"
            label={language[selectedLang]?.common_name}
            name="name"
            placeholder={language[selectedLang]?.customer_name}
            required
            color="primary"
            initValue={formData?.name}
            value={formData.name}
            error={formErrors?.name}
            onChange={handleChange}
          />
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            mt={2}
          >
            <Typography variant="body1">
              {language[selectedLang]?.common_user_status}
            </Typography>
            <Switch
              checked={formData.status}
              onChange={(e) =>
                setFormData({ ...formData, status: e.target.checked })
              }
            />
          </Stack>
          <Box textAlign="end">
            <Button onClick={closeForm} variant="contained" sx={{ mr: "4px" }}>
              {language[selectedLang]?.common_cancel}
            </Button>
            <Button
              variant="contained"
              type="submit"
              disabled={!formData.name || isLoading}
            >
              {isLoading && <CircularProgress size={16} color="primary" />}
              {formData.type === "ADD"
                ? language[selectedLang]?.common_add
                : language[selectedLang]?.common_save}
            </Button>
          </Box>
        </Stack>
      </Box>
    </Box>
  );
}
